<template>
  <div
    v-if="!component.unavailable_by_date && !(component.hidden_if_unauthorized && !component['#actions']['create'])"
    class="f-vcreator-source"
    @click="!pending && (component.permission_value || !component.no_permission_url) && create()"
    :class="{
      pending,
      disabled: (!component.permission_value || !component['#actions']['create']) && !component.no_permission_url,
      'no-permission-cta': !component.permission_value && component.no_permission_url,
    }"
    v-tippy="{ placement: 'bottom', arrow: true, delay: [150, 300], allowHTML: true, interactive: true, onShow: (i) => !!i.props.content }"
    :title="$vt(component.tooltip)"
  >
    <div v-if="!component.permission_value && component.no_permission_url" class="f-vcreator-source-badge">
      {{ $vt('Available on demand') }}
    </div>
    <f-icon :icon="component.icon"></f-icon>
    <div class="f-title">{{ $vt(component.title) }}</div>
    <f-button
      v-if="!component.permission_value && component.no_permission_url"
      :type="['tertiary']"
      :href="component.no_permission_url"
      blank
    >
      {{ $vt(component.no_permission_message) || $vt('Contact sales') }}
    </f-button>
    <f-button
      v-else
      :pending="pending"
      :type="['secondary']"
      :disabled="!component.permission_value || !component['#actions']['create']"
    >{{ $vt('Add') }}</f-button>
  </div>
</template>

<script>
export default {
  translate25Context: 'vcreator18',
  props: {
    component: Object,
    handler: Object,
  },
  data() {
    return {
      pending: false,
    }
  },
  methods: {
    async create() {
      this.pending = true
      try {
        const result = await this.handler.action(this.component, 'create', [])
        this.$emit('oncreate', { key: result['#result'].created_nid })
      } finally {
        this.pending = false
      }
    },
  },
}
</script>
